
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   记账管理
                </span>
               
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>

               <div>
                   <p class="text-center" style="font-size:20px;">
                       未记账信息
                   </p>
               </div>

              <div>
                    
                    <div class="opt-letter-watch-box ml-4" style="float:left;">
                        <a class="bt-button personal-letter yjz" @click="yjz()">
                            查询已记账
                        </a>
                    </div>
                    <div class="opt-letter-watch-box ml-2" style="float:left;" @click="dz()">

                        <a class="bt-button personal-watch yjz">
                            查询对账
                        </a>
                    </div>
              </div>

            
              
            <div v-if="showPage">

                <div class="mb-3">
                  <p class="text-right mr-3">
                      总金额:
                      <span style="font-weight:700;color:red;font-size:20px;">
                           {{count}}
                      </span>
                  </p>
              </div>

           
            <table  class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>序列号</th>
                        <th>提交人</th>
                        <th>记账方式</th>
                        <th>客户编号</th>
                        <th>客户名称</th>
                        <th>订单备注</th>
                        <th>收货人</th>
                        <th>换票方式</th>
                        <th>客户备注</th>
                        <th>提交时间</th>
                        <th>发货方式</th>
                        <th>订单到期时间</th>
                        <th>金额</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.xlh}}</td>
                              <td class="jz_middle">{{item.yjztjr}}</td>
                              <td class="jz_middle">{{item.jzfs}}</td>
                              <td class="jz_middle">{{item.khbh}}</td>
                              <td class="jz_middle">{{item.khmc}}</td>
                              <td class="jz_middle">{{item.ordersmark}}</td>
                              <td class="jz_middle">{{item.shr}}</td>
                              <td class="jz_middle">{{item.hpfs}}</td>
                              <td class="jz_middle">{{item.mark}}</td>
                              <td class="jz_middle">{{item.inserttime | formatUTC}}</td>
                              <td class="jz_middle">{{item.isby}}</td>
                              <td class="jz_middle">{{item.xdsj | formatUTC}}</td>
                              <td class="jz_middle">{{item.je}}</td>
                      </tr>
                    </tbody>
                  </table>

                    <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                    </div>
                 </div>

                  <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->
                   

     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
      
        isLoading: false,
        count:"",
        tableData: [],
        showPage:false,
        details:[],
        totalLimitMoney:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components:{
        vPagination,
    },
    computed:{
         
},
filters: {
 
 
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
    
},

methods: {

    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {

         //获取三个月前的时间戳   时间条件适合才可以查询

         const that = this
      
      
          // this.isLoading=true;
        const { data: res } = await that.$http.post('DsApi/DsGetfun', {
          action: 'DsapiManagemen',
          obj: JSON.stringify({
             jztype:0,
              pageIndex:PageIndex
          }) 
        })
         console.log(res)
           if(res.isok){
                const obj=res.data
                that.tableData = obj.rows
                 that.total = obj.record
                 that.count = obj.count
                if(that.tableData.length>0)
                {

                    that.showPage=true;
                   
                }
                else{
                    that.showPage =false;
                }
             
           }
        

       
         
      },
     pagechange:function(currentPage){
     

           this.getClerkStoreGoodsQuery(currentPage);
         
     },
        yjz(){
            this.$router.push({path: '/haveaccount'})
       },
       dz(){
             this.$router.push({path: '/checkAccount'})
       }

  
    },
     mounted(){
    },
     created () {
     
        this.getClerkStoreGoodsQuery(1);
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;

  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .opt-letter-watch-box {
    color: #f5a523;
    font-size: 12px;
    width: 126px;
    height: 28px;
    border-radius: 14px;
    line-height: 26px;
 
}
.personal-letter {
    border: 1px solid #fc5531;
    background-color: #fff;
    color: #fc5531!important;
    line-height: 28px;
    border-radius: 14px;
}
.bt-button {
    display: block;
    border-radius: 14px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
    font-size: 14px;
    text-align:center;
}
.yjz{
    cursor: pointer;
}
.personal-watch {
    background: linear-gradient(92deg,#ffba40 0%,#ff503e 37%,#ff2f50 81%,#ff1b40 100%);
    color: #fff !important;
    line-height: 26px;
    border-radius: 14px;
}

</style>


// WEBPACK FOOTER //
// src/pages/Administrator/Accounts.vue